import React from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useChildMatches } from "@tanstack/react-router";

import TelusLogo from "src/assets/mightier_telus_logo.svg";
// ui
import { AppShell, Group, Stack, Title, Image, Center } from "@mantine/core";
import { SpringOnboardingTitle } from "@components/Typography";
import { useColors } from "@utils/useColors";

function SpringHealthHeader() {
  const { t } = useTranslation();
  const themeColors = useColors();

  return (
    <Center p="md">
      <Stack gap="xs" align="center">
        <Title ff="Rammetto One" fw="400" c={themeColors.tufts100}>
          MIGHTIER
        </Title>
        <SpringOnboardingTitle order={2}>
          {t("springHealth.layout.header")}
        </SpringOnboardingTitle>
      </Stack>
    </Center>
  );
}

function TelusHeader() {
  return (
    <AppShell.Header>
      <Group p="md">
        <Image src={TelusLogo} w={{ xs: "50%", sm: "30%" }} />
      </Group>
    </AppShell.Header>
  );
}

export function EnrollmentFlowLayout(): React.ReactElement {
  const showSpringHeader = useChildMatches({
    select: (matches) => {
      return matches.some((match) => {
        const isSpring = match.routeId.startsWith("/spring-health");
        return isSpring && match.routeId !== "/spring-health/verify";
      });
    },
  });

  const showTelusHeader = useChildMatches({
    select: (matches) =>
      matches.some((match) => match.routeId.startsWith("/telus")),
  });

  return (
    <AppShell>
      {showTelusHeader ? <TelusHeader /> : null}
      <AppShell.Main mt={{ xs: "xs", md: "xl" }} px={{ xs: "xs", sm: "8%" }}>
        {showSpringHeader ? <SpringHealthHeader /> : null}
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
}
